import React, {
  useEffect,
} from "react";

import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  Chip,
  Avatar,
  CircularProgress,
} from "@mui/material";

import {
  useParams,
} from "react-router-dom";

import {
  useDispatch,
  useSelector,
} from "react-redux";

import {
  getRestaurantDetails,
} from "../redux/slices/adminRestaurantSlice";

const RestaurantDetails = () => {
  const { id } = useParams();

  const dispatch =
    useDispatch();

  const {
    restaurantDetails,
    loading,
  } = useSelector(
    (state) =>
      state.adminRestaurant
  );

  useEffect(() => {
    dispatch(
      getRestaurantDetails(id)
    );
  }, [dispatch, id]);

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        mt={5}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box>
      <Typography
        variant="h4"
        fontWeight={700}
        mb={3}
      >
        Restaurant Details
      </Typography>

      <Card>
        <CardContent>
          <Box
            display="flex"
            alignItems="center"
            gap={2}
            mb={3}
          >
            <Avatar
              src={
                restaurantDetails
                  ?.profileImage?.url
              }
              sx={{
                width: 80,
                height: 80,
              }}
            />

            <Box>
              <Typography
                variant="h5"
              >
                {
                  restaurantDetails?.restaurantName
                }
              </Typography>

              <Typography>
                Owner:
                {
                  restaurantDetails?.ownerName
                }
              </Typography>
            </Box>
          </Box>

          <Grid
            container
            spacing={2}
          >
            <Grid item xs={12} md={6}>
              <Typography>
                Mobile:
                {
                  restaurantDetails?.mobile
                }
              </Typography>
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography>
                WhatsApp:
                {
                  restaurantDetails?.whatsappNumber
                }
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography>
                Address:
                {
                  restaurantDetails?.restaurantAddress
                }
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography>
                Subscription:
              </Typography>

              <Chip
                label={
                  restaurantDetails?.subscriptionStatus
                }
                color={
                  restaurantDetails
                    ?.subscriptionStatus ===
                  "ACTIVE"
                    ? "success"
                    : "warning"
                }
              />
            </Grid>

            <Grid item xs={12}>
              <Typography>
                Plan Start:
                {new Date(
                  restaurantDetails?.planStartDate
                ).toLocaleDateString()}
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography>
                Plan Expiry:
                {new Date(
                  restaurantDetails?.planExpiryDate
                ).toLocaleDateString()}
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography>
                Grace Expiry:
                {new Date(
                  restaurantDetails?.graceExpiryDate
                ).toLocaleDateString()}
              </Typography>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Box>
  );
};

export default RestaurantDetails;